// extracted by mini-css-extract-plugin
module.exports = {"container":"Popover_container__1gmQP","title":"Popover_title__3g1TH"};